import BillingResource from '@/resources/BillingResource';

export default class Billing {
    constructor() {
        this.Resource = new BillingResource()
    }

    async get () {
        const billing = await this.Resource.get()
        return billing.data
    }

    async checkPlan (id) {
        return await this.Resource.checkPlan(id)
    }

    async getPlanApplyings (id) {
        const plans = await this.Resource.getPlanApplyings(id)
        return plans.data
    }

    async getPaymentMethods() {
        const method = await this.Resource.getPaymentMethods()
        return method.data
    }

    async set() {
        const billing = await this.Resource.set()
        return billing.data.url
    }

    async requestUpdatePaymentInfo(desirePaymentMethod) {
        const requestUpdatePaymentInfoQuery = await this.Resource.requestUpdatePaymentInfo(desirePaymentMethod)

        return requestUpdatePaymentInfoQuery.data.requestUpdatePaymentInfoQuery
    }

    async reactivate() {
        const billing = await this.Resource.reactivate()
        return billing.data.url
    }
}
